import React from 'react'
import Topbar from './Topbar'
import Navbar from './Navbar'
import Footer from './Footer'
import Image1 from '../images/About-Us/BoardMembers.jpeg'
import AboutUsLogo from '../images/Aboutus-img.png'
import '../css/Aboutus.css'

const AboutUs = () => {

    document.title = `हलिं नेवा: गुथि | झिगु खंय्`

    return (
        <>
            <div className="header-top">
                <Topbar />
            </div>

            <div className="header-navbar">
                <Navbar />
            </div>

            <div className='about-head'>
                {/* <h1>Contact Us</h1> */}
                <img src={AboutUsLogo} alt="aboutus" />
                <h1> / झिगु खंय्</h1>
            </div>

            <div className='about-content'>
                <img src={Image1} alt="gallery-1" />
            </div>

            <div className="footer-links">
                <Footer />
            </div>

        </>
    )
}

export default AboutUs